import * as common from "@/assets/common/common";
import { Product } from "@/model/product";
import { Member } from "@/model/member";
import { OrgUser, OrgUserBase, OrganizationType } from "@/model/organization";
import { getCallable } from "@/config/env";
import * as env from "@/config/env.json";

declare global {
  interface Window {
    daum: any;
  }
}

export function getActivityProductSetList() {
  const prods = [
    [
      {
        SK: "activity_e#0001",
        name: "PUTT2.0기반 재능탐색_초등학생(고학년) : 진단(1시간) + 안내(0.5시간) + 활동 / 발표(2.5시간) (PUTT2.0 포함)",
        price: 40000,
        type: "putt_e",
      },
      {
        SK: "activity_e#0002",
        name: "꿈‧창업 프로젝트_초등학생(고학년) : 안내(1시간) + 활동 / 발표(2시간)",
        price: 30000,
        type: "activity_startup_e",
      },
      {
        SK: "activity_e#0003",
        name: "데이터사이언스 체험 활동_초등학생(6학년) : 안내(1시간) + 활동 / 발표(2시간)",
        price: 30000,
        type: "activity_ds_e",
      },
    ],
    [
      {
        SK: "activity_m#0001",
        name: "PUTT2.0기반 진로 탐색_중학생 + 진단(1시간) + 안내/활동/발표(3시간) (PUTT2.0 포함)",
        price: 40000,
        type: "putt_m",
      },
      {
        SK: "activity_m#0002",
        name: "꿈‧창업 프로젝트_중학생: 안내/ 활동/ 발표",
        price: 30000,
        type: "activity_startup_m",
      },
      {
        SK: "activity_m#0003",
        name: "데이터사이언스 체험 활동_중학생: 안내/ 활동/ 발표",
        price: 30000,
        type: "activity_ds_m",
      },
      {
        SK: "activity_m#0004",
        name: "성장-폴리오_중학생: 안내/ 활동/ 발표",
        price: 30000,
        type: "activity_folio_m",
      },
    ],
    [
      {
        SK: "activity_h#0001",
        name: "PUTT2.0기반 전공 탐색_고등학생 + 진단(1시간) + 안내/활동/발표(3시간) (PUTT2.0 포함)",
        price: 40000,
        type: "putt_h",
      },
      {
        SK: "activity_h#0002",
        name: "꿈‧창업 프로젝트_고등학생: 안내/ 활동/ 발표",
        price: 30000,
        type: "activity_startup_h",
      },
      {
        SK: "activity_h#0003",
        name: "데이터사이언스 체험 활동_고등학생: 안내/ 활동/ 발표",
        price: 30000,
        type: "activity_ds_h",
      },
      {
        SK: "activity_h#0004",
        name: "성장-폴리오_고등학생: 안내/ 활동/ 발표",
        price: 30000,
        type: "activity_folio_h",
      },
    ],
    [
      {
        SK: "activity_u#0001",
        name: "PUTT2.0기반 직업 탐색_대학생 + 진단(1시간) + 안내/활동/발표(3시간) (PUTT2.0 포함)",
        price: 60000,
        type: "putt_u",
      },
      {
        SK: "activity_u#0002",
        name: "데이터사이언스 체험 활동_대학생 : 안내/ 활동/ 발표",
        price: 60000,
        type: "activity_ds_u",
      },
      {
        SK: "activity_u#0003",
        name: "성장-폴리오_대학생: 안내/ 활동/ 발표",
        price: 60000,
        type: "activity_folio_u",
      },
    ],
  ];
  return prods;
}

export function getExpertProductSetList() {
  const prods = [
    {
      SK: "export_#0001",
      name: "PUTT2.0 학습진로상담 전문가교육 - 초급과정",
      price: 200000,
      type: "expert_putt_e",
    },
    {
      SK: "export_#0002",
      name: "PUTT2.0 학습진로상담 전문가교육 - 고급과정",
      price: 250000,
      type: "expert_putt_h",
    },
    {
      SK: "export_#0003",
      name: "PUTT2.0 학습진로상담 전문가교육 - 최고과정",
      price: 300000,
      type: "expert_putt_e",
    },
    {
      SK: "export_#0004",
      name: "성장‧폴리오 전문가 과정",
      price: 200000,
      type: "expert_growth",
    },
  ];
  return prods;
}

let prodSetListCache: Product[][] | null = null;
let prodInfoList: Product[] | null = null;

export async function getProductSetList(): Promise<Product[][]> {
  if (prodInfoList && prodInfoList.length > 0 && prodSetListCache) {
    return prodSetListCache;
  }

  const getProductsCallable = getCallable("getProducts");
  const result = await getProductsCallable();
  prodInfoList = common.getItemListFromFunctionResult(result) as Product[];
  const typeMap = new Map();
  for (const prodInfo of prodInfoList) {
    if (prodInfo.type && prodInfo.SK) typeMap.set(prodInfo.type, prodInfo);
  }
  const newProdSetList: Product[][] = [
    [
      typeMap.get("putt_e"),
      typeMap.get("tocc_e"),
      typeMap.get("coach_putt_e"),
      typeMap.get("coach_tocc_e"),
      typeMap.get("coach_putt_tocc_e"),
    ],
    [
      typeMap.get("putt_m"),
      typeMap.get("tocc_h"),
      typeMap.get("coach_putt_m"),
      typeMap.get("coach_tocc_m"),
      typeMap.get("coach_putt_tocc_m"),
    ],
    [
      typeMap.get("putt_h"),
      typeMap.get("tocc_h"),
      typeMap.get("coach_putt_h"),
      typeMap.get("coach_tocc_h"),
      typeMap.get("coach_putt_tocc_h"),
    ],
    [
      typeMap.get("putt_u"),
      typeMap.get("tec"),
      typeMap.get("coach_putt_u"),
      typeMap.get("coach_tec"),
      typeMap.get("coach_putt_tec"),
    ],
  ];

  prodSetListCache = newProdSetList;
  return prodSetListCache;
}

export async function getProduct(
  prodType: string
): Promise<Product | undefined> {
  if (!prodInfoList || prodInfoList.length == 0) {
    const getProductsCallable = getCallable("getProducts");
    const result = await getProductsCallable();
    prodInfoList = common.getItemListFromFunctionResult(result) as Product[];
  }

  const findProd = prodInfoList.find((c) => c.type === prodType);
  return findProd;
}

export function openDaumPostcode(onComplete: (data: any) => void): void {
  if (!window.daum || !window.daum.Postcode) {
    const script = document.createElement("script");
    script.src =
      "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    script.onload = () => {
      new window.daum.Postcode({ oncomplete: onComplete }).open();
    };
    document.head.appendChild(script);
  } else {
    new window.daum.Postcode({ oncomplete: onComplete }).open();
  }
}

export function getDate(dateTime: any) {
  const d = new Date(Number(dateTime));
  let month = (d.getMonth() + 1) as any;
  month = month < 10 ? "0" + month : month;
  let date = d.getDate() as any;
  date = date < 10 ? "0" + date : date;
  let hours = d.getHours() as any;
  hours = hours < 10 ? "0" + hours : hours;
  let minutes = d.getMinutes() as any;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  let seconds = d.getSeconds() as any;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return (
    d.getFullYear() +
    "-" +
    month +
    "-" +
    date +
    " " +
    hours +
    ":" +
    minutes +
    ":" +
    seconds
  );
}

export function getYYYYMMDD(timestamp: any) {
  const parsedDate = new Date(Number(timestamp));
  let yyyymmdd = "";
  const year = parsedDate.getFullYear().toString();
  let month = (parsedDate.getMonth() + 1).toString();
  let date = parsedDate.getDate().toString();
  date.length == 1 && (date = "0" + date);
  month.length == 1 && (month = "0" + month);
  yyyymmdd = year + month + date;
  return yyyymmdd;
}

export function getYYYYMM(timestamp: any) {
  const parsedDate = new Date(Number(timestamp));

  let yyyymm = "";
  const year = parsedDate.getFullYear().toString();
  let month = (parsedDate.getMonth() + 1).toString();
  month.length == 1 && (month = "0" + month);
  yyyymm = year + month;
  return yyyymm;
}

export function getYYYY(timestamp: any) {
  const parsedDate = new Date(Number(timestamp));
  let yyyy = "";
  const year = parsedDate.getFullYear().toString();
  yyyy = year;
  return yyyy;
}

export function getYYYYMMDD2(timestamp: any) {
  const parsedDate = new Date(Number(timestamp));
  let yyyymmdd = "";
  const year = parsedDate.getFullYear().toString();
  let month = (parsedDate.getMonth() + 1).toString();
  let date = parsedDate.getDate().toString();
  date.length == 1 && (date = "0" + date);
  month.length == 1 && (month = "0" + month);
  yyyymmdd = `${year}-${month}-${date}`;
  return yyyymmdd;
}

export function getYYYYMMDD3(dateTime: any) {
  const d = new Date(Number(dateTime));
  let month = (d.getMonth() + 1) as any;
  month = month < 10 ? "0" + month : month;
  let date = d.getDate() as any;
  date = date < 10 ? "0" + date : date;

  return d.getFullYear() + "-" + month + "-" + date;
}

export function deepCopy(o: any) {
  return JSON.parse(JSON.stringify(o));
}

export function formatDateToYYYY_MM_DD(date: Date): string {
  const year = date.getFullYear();
  // getMonth()는 0부터 시작하므로 (0=1월, 1=2월, ...), +1 해줍니다.
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function asyncFunction(f: any) {
  setTimeout(() => f(), 1);
}

export function formatPrice(price: number): string {
  const number = Number(price);
  if (isNaN(number)) return "0원";
  return number.toLocaleString() + "원";
}

export function getLocalAuth(): Member | OrgUser {
  const loginInfo: any = JSON.parse(localStorage.getItem("auth") || "{}");
  if (
    "orgId" in loginInfo &&
    (loginInfo.type === "admin" || loginInfo.type === "user")
  ) {
    const user: OrgUser = {
      ...loginInfo,
    };
    return user;
  } else {
    const user: Member = {
      ...loginInfo,
    };
    return user;
  }
}

export function setLocalAuth(authInfo: Member | OrgUser): void {
  localStorage.setItem("auth", JSON.stringify(authInfo));
}

export function removeLocalAuth() {
  localStorage.setItem("auth", "");
}

export function getLastEvaluatedKey(result: {
  [key: string]: any;
}): string | undefined {
  if (
    result &&
    result.data &&
    result.data.data &&
    result.data.data.LastEvaluatedKey
  ) {
    return result.data.data.LastEvaluatedKey;
  } else {
    return undefined;
  }
}

export function getItemListFromFunctionResult(result: {
  [key: string]: any;
}): { [key: string]: any }[] {
  if (result && result.data && result.data.data && result.data.data.Items) {
    return result.data.data.Items;
  } else {
    return [];
  }
}

export function getItemFromFunctionResult(result: {
  [key: string]: any;
}): { [key: string]: any } | null {
  if (result && result.data && result.data.data && result.data.data.Item) {
    return result.data.data.Item;
  } else {
    return null;
  }
}
export function getToken(result: { [key: string]: any }): string | null {
  if (result && result.data && result.data.data && result.data.data.token) {
    return result.data.data.token;
  } else {
    return null;
  }
}

export function evalFunctionResult(result: { [key: string]: any }): boolean {
  if (getResultMessage(result) === "success") {
    return true;
  } else {
    return false;
  }
}

export function getResultMessage(result: { [key: string]: any }): string {
  if (result && result.data && result.data.message) {
    return result.data.message;
  } else {
    return "";
  }
}

export function getResultError(result: { [key: string]: any }): string {
  if (result && result.data && result.data.error) {
    return result.data.error;
  } else {
    return "";
  }
}
export function getResultCode(result: { [key: string]: any }): string {
  if (result && result.data && result.data.code) {
    return result.data.code;
  } else {
    return "";
  }
}

export function getYYYMMDDStringFormat(dateString?: string) {
  if (!dateString) return "N/A";

  if (dateString.length == 8) {
    return (
      dateString.substring(0, 4) +
      "-" +
      dateString.substring(4, 6) +
      "-" +
      dateString.substring(6, 8)
    );
  } else {
    return dateString;
  }
}

export function getGenderString(gender: string): string {
  if (!gender) return "N/A";

  if (
    gender === "남" ||
    gender === "남자" ||
    gender.toLocaleLowerCase() === "m" ||
    gender.toLocaleLowerCase() === "male"
  )
    return "남";
  else if (
    gender === "여" ||
    gender === "여자" ||
    gender.toLocaleLowerCase() === "f" ||
    gender.toLocaleLowerCase() === "female"
  )
    return "여";
  else return "N/A";
}

export const getOrganizationTypeString = (
  type: OrganizationType | undefined | null
): string => {
  if (!type) return "N/A";
  switch (type) {
    case OrganizationType.ElementarySchool:
      return "초등학교";
    case OrganizationType.MiddleSchool:
      return "중학교";
    case OrganizationType.HighSchool:
      return "고등학교";
    case OrganizationType.University:
      return "대학교";
    case OrganizationType.Etc:
      return "기타 기관(법인/재단 등)";
    default:
      return type || "알 수 없음"; // type이 enum에 없는 문자열일 경우 그대로 반환
  }
};

export function formatNumberWithCommas(price: any): string {
  const priceNum = Number(price);
  return priceNum.toLocaleString();
}

export function getProjectName(type: string): string {
  const typeL = type.toLocaleLowerCase();
  if (typeL == "putt_e") return "다중재능검사 PUTT2.0_초등학생용";
  else if (typeL == "putt_m") return "다중재능검사 PUTT2.0_중학생용";
  else if (typeL == "putt_h") return "다중재능검사 PUTT2.0_고등학생용";
  else if (typeL == "putt_u") return "다중재능검사 PUTT2.0_대학생용";
  else if (typeL == "tocc_e") return "창의역량검사 TOCC_아동용";
  else if (typeL == "tocc_h") return "창의역량검사 TOCC_청소년용";
  else if (typeL == "tec") return "창의역량검사 TEC_전문가용";
  else return "알수없음";
}

export function getSurveyUrl(projectSK: string) {
  return `${env.user_domain}/Survey/${encodeURIComponent(projectSK)}`;
}

export function formatDateToYYYYMMDD2(date: Date): string {
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();
  month.length == 1 && (month = "0" + month);
  day.length == 1 && (day = "0" + day);
  return `${date.getFullYear()}-${month}-${day}`;
}

